import React from 'react';
import { teamLabel, teamTone } from '../../utils/teams';
import type { Team } from '../../types/voip';
export function TeamBadge({
  team
}: {
  team: Team;
}) {
  return <span className={`inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${teamTone[team]}`} data-id="element-147" data-mp="her7j1e80lgp">
      {teamLabel(team)}
    </span>;
}